angular.module("UI8.components").component("shotCard", {
  template:
    '<div class="shot">' +
    '  <a class="shot__media" ng-href="{{::$ctrl.link}}" ng-style="::{\'background-color\': $ctrl.color}">' +
    '    <img ng-src="{{::$ctrl.cardImage}}" ng-srcset="{{::$ctrl.cardSrcset}}" loading="lazy" alt="{{::$ctrl.shot.title}}" ui8-fade-in>' +
    '    <span class="shot__overlay"><span class="shot__name">{{ ::$ctrl.shot.title }}</span></span>' +
    "  </a>" +
    '  <div class="shot__meta">' +
    '    <a class="shot__author" ng-href="{{::$ctrl.authorLink}}">' +
    '      <img class="shot__avatar" ng-src="{{::$ctrl.authorAvatar}}" loading="lazy" alt="">' +
    '      <span class="shot__by">{{ ::$ctrl.authorName }}</span>' +
    "    </a>" +
    '    <div class="shot__stats">' +
    '      <button class="shot__like" ng-if="$ctrl.user" ng-class="{active: $ctrl.shot.liked}" ng-click="$ctrl.toggleLike()">' +
    '        <svg viewBox="0 0 24 24"><path d="M21 10c0 5.75-8.25 10-9 10s-9-4.25-9-10c0-4 2.5-6 5-6s4 1.5 4 1.5S13.5 4 16 4s5 2 5 6Z"/></svg>' +
    "        <span>{{ $ctrl.shot.likes || 0 }}</span>" +
    "      </button>" +
    '      <a class="shot__like" ng-if="!$ctrl.user" href="/account/signup">' +
    '        <svg viewBox="0 0 24 24"><path d="M21 10c0 5.75-8.25 10-9 10s-9-4.25-9-10c0-4 2.5-6 5-6s4 1.5 4 1.5S13.5 4 16 4s5 2 5 6Z"/></svg>' +
    "        <span>{{ $ctrl.shot.likes || 0 }}</span>" +
    "      </a>" +
    '      <span class="shot__eye">' +
    '        <svg viewBox="0 0 12 12"><path d="M5.99997 10.25C8.64947 10.25 10.2021 8.38538 10.9485 7.12628C11.3599 6.43238 11.3599 5.56762 10.9485 4.87372C10.2021 3.61462 8.64937 1.75 5.99997 1.75C3.42267 1.75 1.87667 3.53288 1.10727 4.78918C0.649466 5.53658 0.649466 6.46338 1.10727 7.21088C1.87667 8.46718 3.42267 10.25 5.99997 10.25Z" stroke-linecap="round" stroke-linejoin="round"/><path data-color="color-2" d="M6 7.25C6.69 7.25 7.25 6.69 7.25 6C7.25 5.31 6.69 4.75 6 4.75C5.31 4.75 4.75 5.31 4.75 6C4.75 6.69 5.31 7.25 6 7.25Z" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
    "        <span>{{ ::$ctrl.shot.views || 0 }}</span>" +
    "      </span>" +
    "    </div>" +
    "  </div>" +
    "</div>",

  controller: function (ShotService) {
    var $ctrl = this;

    var S3_IMAGE_SERVER = "https://images.ui8.net";
    var DEFAULT_AVATAR =
      "//d1v8dk3ka6obgr.cloudfront.net/v5/assets/global/default_avatar_v2.png";

    this.toggleLike = function () {
      ShotService.toggleLike($ctrl.shot);
    };

    this.$onInit = function () {
      var shot = this.shot;
      var author = shot.author || {};
      var image = (shot.images && shot.images[0]) || {};

      this.link = "/shots/" + shot.slug;

      if (image.resized) {
        var prefix =
          S3_IMAGE_SERVER + "/shot/" + shot._id + "/" + image._id + "_card";
        this.cardImage = prefix + "_" + image.version + ".webp";
        this.cardSrcset =
          this.cardImage +
          " 1x, " +
          prefix +
          "_2x_" +
          image.version +
          ".webp 2x";
      } else {
        this.cardImage = image.url;
        this.cardSrcset = "";
      }

      this.color = image.color || "";

      this.authorLink = "/users/" + (author.display_name_slug || author._id);
      this.authorName =
        author.display_name ||
        ((author.first_name || "") + " " + (author.last_name || "")).trim() ||
        "A designer";

      if (author.has_resized_avatar) {
        var postfix = author.avatar_url_version
          ? "_" + author.avatar_url_version
          : "";
        this.authorAvatar =
          S3_IMAGE_SERVER +
          "/avatar/" +
          author._id +
          "/40_40" +
          postfix +
          ".png";
      } else {
        this.authorAvatar = author.avatar_url || DEFAULT_AVATAR;
      }
    };
  },

  bindings: {
    shot: "<",
    user: "<",
  },
});
